import { apiUrl, authHeaders } from "./httpAuth";

export async function fetchCaceriasAll(estado) {
    const qs = estado ? `?estado=${encodeURIComponent(estado)}` : "";
    const res = await fetch(apiUrl(`api/cacerias/all${qs}`), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchCaceriaById(id) {
    const res = await fetch(apiUrl(`api/cacerias/${id}`), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchPersonasAll() {
    const res = await fetch(apiUrl("api/personas/all"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchRolesAll() {
    const res = await fetch(apiUrl("api/roles/all"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchArmasAll() {
    const res = await fetch(apiUrl("api/armas/all"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchEventosAll() {
    const res = await fetch(apiUrl("api/eventos/all"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchTipoCaceriaEnum() {
    const res = await fetch(apiUrl("api/enums/tipo-caceria"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
